let html = document.documentElement;

// Main navigation
function toggleNav() {
  window.requestAnimationFrame(() => {
    html.classList.toggle('show-nav');
  })
}
function closeNav() {
  window.requestAnimationFrame(() => {
    html.classList.remove('show-nav');
  })
}
function openNav() {
  window.requestAnimationFrame(() => {
    html.classList.add('show-nav');
  })
}

Array.from(document.querySelectorAll('[data-nav-toggle]')).forEach((elem) => {
  elem.addEventListener('click', toggleNav)
})
Array.from(document.querySelectorAll('[data-nav-close]')).forEach((elem) => {
  elem.addEventListener('click', closeNav)
})


// Sidenav collapsibles
function toggleCollapse(e) {
  e.preventDefault()
  let link, tggl
  if(this.hasAttribute('data-subnav-toggle')) {
    tggl = this
    link = this.parentElement
  } else {
    link = this
    tggl = link.querySelector('[data-subnav-toggle]')
  }

  let sub = link.nextElementSibling
  
  window.requestAnimationFrame(() => {
    if (sub.classList.contains('collapsed')){
      sub.classList.remove('collapsed')
      tggl.classList.remove('collapsed')
      sub.style.maxHeight = sub.scrollHeight + "px";
    } else {
      sub.classList.add('collapsed')
      tggl.classList.add('collapsed')
      sub.style.maxHeight = "0px";
    }
  })
}

Array.from(document.querySelectorAll('[data-subnav-toggle]')).forEach((tggl) => {
  let link = tggl.parentElement
  let sub = link.nextElementSibling
  window.requestAnimationFrame(() => {
    sub.style.maxHeight = sub.scrollHeight + "px";
  })
  
  if (link.hasAttribute('href') && link.getAttribute('href') != '') {
    tggl.addEventListener('click', toggleCollapse)
  } else {
    link.addEventListener('click', toggleCollapse)
  }
})